<template>
  <div class="html-input">
    <ValidationProvider
      v-slot="{ errors }"
      :name="label"
      :rules="validationRules"
    >
      <div
        class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
      >
        <div class="vs-con-input">
          <label
            v-if="label || required"
            :for="`input-${name}`"
            class="vs-input--label"
            >{{ label }}
            <span v-if="required" class="text-danger"
              ><feather-icon icon="star-of-life"/></span
          ></label>
          <quill-editor
            ref="myQuillEditor"
            v-model="internalValue"
            class="data-input"
            :options="computedEditorOptions"
            :placeholder="placeholder"
            :class="{ error: errors.length }"
          />
        </div>
      </div>
      <span v-show="errors.length" class="text-danger text-sm">{{
        errors[0]
      }}</span>
    </ValidationProvider>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import { quillEditor } from "vue-quill-editor";

export default {
  components: {
    quillEditor
  },
  props: {
    value: { type: String, default: null },
    validationRules: {
      type: [Object, String],
      default() {
        return null;
      }
    },
    toolbarOptions: {
      type: Array,
      default() {
        return [
          [{ size: ["small", false, "large", "huge"] }], // custom dropdown
          [{ header: [1, 2, 3, 4, 5, 6, false] }],

          ["bold", "italic", "underline", "strike"], // toggled buttons

          [{ list: "ordered" }, { list: "bullet" }],
          [{ indent: "-1" }, { indent: "+1" }], // outdent/indent

          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          [{ align: [] }],

          ["clean"] // remove formatting button
        ];
      }
    },
    label: { type: String, default: null },
    placeholder: { type: String, default: null },
    name: { type: String, required: true },
    required: { type: Boolean, default: false }
  },
  data: () => ({
    editorOption: {
      placeholder: ""
    }
  }),
  computed: {
    computedEditorOptions() {
      return Object.assign(
        {
          modules: {
            toolbar: this.toolbarOptions
          }
        },
        this.editorOption
      );
    },
    internalValue: {
      get() {
        return this.value || "";
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  mounted() {
    this.editorOption.placeholder = this.placeholder;
  }
};
</script>
